import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const findDatabaseUserByEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/database-user/email`, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    console.error('Error looking up database user by email:', error.response?.data || error);
    throw error;
  }
};

export const checkDatabaseUserPhoneExists = async (phoneNumber, countryCode) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/database-user/phone-exists`, {
      params: { phoneNumber, countryCode },
    });
    return response.data;
  } catch (error) {
    console.error('Error checking database user phone:', error.response?.data || error);
    throw error;
  }
};

// GET all databaseUsers
export const getDatabaseUsers = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/api/databaseUsers`);
    return response.data;
  } catch (error) {
    console.error("Error fetching databaseUsers:", error.response?.data || error);
    throw error;
  }
};

// GET a single databaseUser
export const getDatabaseUserById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/api/databaseUsers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching databaseUser:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new databaseUser
export const createDatabaseUser = async (databaseUserData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/api/databaseUsers`, databaseUserData);
    return response.data;
  } catch (error) {
    console.error("Error creating databaseUser:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing databaseUser
export const updateDatabaseUser = async (id, databaseUserData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/api/databaseUsers/${id}`, databaseUserData);
    return response.data;
  } catch (error) {
    console.error("Error updating databaseUser:", error.response?.data || error);
    throw error;
  }
};

// DELETE a databaseUser
export const deleteDatabaseUser = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/api/databaseUsers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting databaseUser:", error.response?.data || error);
    throw error;
  }
};
